import ColorConstants from './ColorConstants';

export default  [
  ColorConstants.DARK_GREY,
  ColorConstants.ACTIVE_BUTTON_BLUE,
  '#B7DCF7',
];